import React, { Suspense } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { EVENT_BANNERS, ENABLED_FEATURES } from 'appenv';
import { selectBannersByPosition, BannerPosition } from 'models/banners';
import Background706Img from 'assets/background-706.png';
import Sponsor706Img from 'assets/sponsor-706.png';
import BannerView from '../../BannerTemplateSwitch';
import LobbyFooterSwitch from '../../LobbyFooterSwitch';

const RootContainer = styled.div`
  position: relative;
  width: 100%;
`;

const MainContainer = styled.div`
  position: relative;
`;

const BackgroundImg = styled.img`
  width: 100%;
`;

const SponsorImg = styled.img`
  width: 100%;
  margin-bottom: 50px;
`;

const LeftBannerView = styled(BannerView)`
  position: absolute;
  width: 8.6%;
  height: 24%;
  left: 33.4%;
  top: 45%;
`;

const RightBannerView = styled(BannerView)`
  position: absolute;
  width: 13.4%;
  height: 9.9%;
  left: 46.24%;
  top: 51.7%;
`;

const MiddleBannerView = styled(BannerView)`
  position: absolute;
  width: 41.1%;
  height: 30.3%;
  left: 30.1%;
  top: 12%;
`;

const FooterContainer = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
`;

const DesktopLobbyView = () => {
  const leftBanners = useSelector(selectBannersByPosition(BannerPosition.left));
  const rightBanners = useSelector(selectBannersByPosition(BannerPosition.right));
  const middleBanners = useSelector(selectBannersByPosition(BannerPosition.middle));

  return (
    <RootContainer>
      <MainContainer>
        <BackgroundImg src={Background706Img} />

        <LeftBannerView assets={ENABLED_FEATURES.cmsBanner && middleBanners?.length > 0 ? leftBanners : EVENT_BANNERS.left} />
        <RightBannerView assets={ENABLED_FEATURES.cmsBanner && middleBanners?.length > 0 ? rightBanners : EVENT_BANNERS.right} />
        <MiddleBannerView assets={ENABLED_FEATURES.cmsBanner && middleBanners?.length > 0 ? middleBanners : EVENT_BANNERS.middle} />

        <FooterContainer>
          <Suspense fallback={null}>
            <LobbyFooterSwitch />
          </Suspense>
        </FooterContainer>
      </MainContainer>

      <SponsorImg src={Sponsor706Img} />
    </RootContainer>
  );
};

export default DesktopLobbyView;
